import { Grid, Typography } from "@mui/material";

interface IDetailProps {
  icon: any;
  EndIcon: any;
  value: string;
  children?: any;
  title: string;
  placeholder?: string;
  onClick: Function;
}

export default function DetailComponent(props: IDetailProps) {
  return (
    <Grid
      onClick = {() => props?.onClick()}
      container
      xs={11}
      sx={{
        maxHeight: "75px",
        marginTop: 1,
        marginBottom: 1,
      }}
    >
      <Grid item xs={12}>
        <Typography color={"black"} textAlign={"center"}>
          {props.title}
        </Typography>
      </Grid>

      <Grid
        sx={{
          border: "1px solid black",
          padding: 1,
          "&:active": {
            opacity: 0.5,
          },
        }}
        xs={12}
        container
      >
        {props.icon && (
          <Grid
            item
            xs={2}
            alignItems={"center"}
            display={"flex"}
            flexDirection={"row"}
          >
            {props.icon}
          </Grid>
        )}
        <Grid
          item
          xs={props.icon ? 9 : 12}
          alignItems={"center"}
          display={"flex"}
          flexDirection={"row"}
        >
          <Typography color={"black"} textAlign={"center"}>
            {props.placeholder || props.value}
          </Typography>
        </Grid>
        {props.icon && (
          <Grid
            item
            xs={1}
            alignItems={"center"}
            display={"flex"}
            flexDirection={"row"}
          >
            {props.EndIcon}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
